module.exports = __webpack_public_path__ + "static/media/bijkeuken_2.c9836c22.jpg";